import { UserRejectedRequestError } from "wagmi";

export const isRealError = (error) => {
  if (!error) {
    return false;
  }
  if (error instanceof UserRejectedRequestError) {
    return false;
  }
  if (error?.code === 4001 || error?.code === "ACTION_REJECTED") {
    return false;
  }

  return true;
};
